import React, { useContext } from "react";
import { Route, Redirect } from "react-router-dom";
import { LoginContext } from "../../context/loginContext";

/** Login screen when logged out; redirect home when already authenticated. */
const LoggedInRedirect = ({ component: Component, ...rest }) => {
  const { currentUser } = useContext(LoginContext);

  return (
    <Route
      {...rest}
      render={(props) =>
        !currentUser ? <Component {...props} /> : <Redirect to="/" />
      }
    />
  );
};

export default LoggedInRedirect;
